import React from 'react';

import { Header } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { Box, BoxProps } from 'components/ui';
import { getDesignToken } from 'styles/constants';

export const ButtonsContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.buttonsContainer, style] });

export const HeaderStyled = Header.withConfig({
  focusable: true,
  accessible: true,
  accessibilityRole: 'header',
  color: getDesignToken('text-hero-light'),
  variant: 'hero',
  lineHeight: 'xs',
  fontWeight: 700,
  marginBottom: '$0',
  fontSize: {
    base: '4xl',
    md: '5xl',
    lg: '6xl',
  },
});

export const DisclaimerText = withTypography({
  fontSize: 9,
  mb: '$2',
  style: { alignSelf: 'flex-start' },
});

const styles = StyleSheet.create({
  buttonsContainer: {
    marginTop: 24,
    maxWidth: 300,
  },
});
